/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateValidationCodePayload } from '../model/createValidationCodePayload';
import { IdDataLong } from '../model/idDataLong';
import { SealWithCodePayload } from '../model/sealWithCodePayload';
import { SignatureData } from '../model/signatureData';
import { SignaturePayload } from '../model/signaturePayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SignatureService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Apply
     * 
     * @param sessionId Signature session in the context of which the signature was created
     * @param signatureId Signature
     * @param stepId Step in the context of which the signature was created
     * @param payload Signature to be applied
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applySignature(sessionId: number, signatureId: number, stepId: number, payload?: SignaturePayload, observe?: 'body', reportProgress?: boolean): Observable<IdDataLong>;
    public applySignature(sessionId: number, signatureId: number, stepId: number, payload?: SignaturePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IdDataLong>>;
    public applySignature(sessionId: number, signatureId: number, stepId: number, payload?: SignaturePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IdDataLong>>;
    public applySignature(sessionId: number, signatureId: number, stepId: number, payload?: SignaturePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling applySignature.');
        }

        if (signatureId === null || signatureId === undefined) {
            throw new Error('Required parameter signatureId was null or undefined when calling applySignature.');
        }

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling applySignature.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IdDataLong>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/steps/${encodeURIComponent(String(stepId))}/signatures/${encodeURIComponent(String(signatureId))}/apply`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Apply validation code
     * 
     * @param sessionId Signature session in the context of which the signature was created
     * @param signatureId Signature
     * @param stepId Step in the context of which the signature was created
     * @param payload Seal to process
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applyValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: SealWithCodePayload, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public applyValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: SealWithCodePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public applyValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: SealWithCodePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public applyValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: SealWithCodePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling applyValidationCodeSignature.');
        }

        if (signatureId === null || signatureId === undefined) {
            throw new Error('Required parameter signatureId was null or undefined when calling applyValidationCodeSignature.');
        }

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling applyValidationCodeSignature.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/steps/${encodeURIComponent(String(stepId))}/signatures/${encodeURIComponent(String(signatureId))}/apply-validation-code`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate validation code
     * 
     * @param sessionId Signature session in the context of which the signature was created
     * @param signatureId Signature
     * @param stepId Step in the context of which the signature was created
     * @param payload Validation code to create
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: CreateValidationCodePayload, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public generateValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: CreateValidationCodePayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public generateValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: CreateValidationCodePayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public generateValidationCodeSignature(sessionId: number, signatureId: number, stepId: number, payload?: CreateValidationCodePayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling generateValidationCodeSignature.');
        }

        if (signatureId === null || signatureId === undefined) {
            throw new Error('Required parameter signatureId was null or undefined when calling generateValidationCodeSignature.');
        }

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling generateValidationCodeSignature.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/steps/${encodeURIComponent(String(stepId))}/signatures/${encodeURIComponent(String(signatureId))}/generate-validation-code`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of signatures
     * 
     * @param sessionId Signature session in the context of which the signature was created
     * @param stepId Step in the context of which the signature was created
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSignatureList(sessionId: number, stepId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SignatureData>>;
    public getSignatureList(sessionId: number, stepId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SignatureData>>>;
    public getSignatureList(sessionId: number, stepId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SignatureData>>>;
    public getSignatureList(sessionId: number, stepId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling getSignatureList.');
        }

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling getSignatureList.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SignatureData>>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/steps/${encodeURIComponent(String(stepId))}/signatures`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
